/* eslint-disable @typescript-eslint/naming-convention */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { ImageType, ImageTypes } from '../models/imageType';
import { BatchEdit } from '../models/batchEdit';
import { ImageService } from '../services/image.service';
import { AppGlobalsService } from '../app-globals.service';
import { State } from '../models/state';
import { Battle } from '../models/battle';
import { Army } from '../models/army';
import { LU_Keyword } from '../models/keyword';
import { Weapon } from '../models/weapon';
import { QMManual } from '../models/qmmanual';
import { RelatedSetLinkingModel } from '../models/relatedSetLinkingModel';
import { RelatedSetService } from '../services/related-set.service';
import { BoundImageSet } from '../models/boundImageSet';
import { BoundSetService } from '../services/bound-set.service';
import { LookupDataService } from '../services/lookup-data.service';
import { AlphaSortArrayByProperty, MONTHS, WriteOrdinalSuffixOfNumber } from 'starbase-launcher';
import { StarbaseNotificationSentiment, StarbaseNotificationService } from 'starbase-notification';
import { AppInsightsService } from '../app-insights.service';
import { ImageDate } from '../models/imageDate';
import { UnitArmies, UnitLinking } from '../models/unitLinking';
import { Regiment } from '../models/regiment';
import { BranchOfService } from '../models/branchOfService';
import { WeaponLinking } from '../models/weaponLinking';
import { QMManualLink } from '../models/qmmanuallink';
import { ImageIndividual } from '../models/imageIndividual';
import { RankCategory } from '../models/rankCategory';
import { Rank } from '../models/rank';
import { PrimaryWeapon } from '../models/primaryWeapon';
import { map, Observable, startWith } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ImageFile } from '../models/imageFile';

@Component({
  selector: 'app-batch-edit-pane',
  templateUrl: './batch-edit-pane.component.html',
  styleUrls: ['./batch-edit-pane.component.css']
})
export class BatchEditPaneComponent implements OnInit {
  @Input() newImages = false;
  @Input() imageType: ImageType;
  @Input() darkMode = false;
  @Input() imageModels: ImageFile[] = [];

  @Output() closeEmitter = new EventEmitter();
  @Output() recordUpdateEmitter = new EventEmitter();
  @Output() processCompleteEmitter = new EventEmitter();

  record: BatchEdit;
  setMode = 0;
  showUnitBuilder = false;
  showIndividualEditor = false;
  individualEditMode = false;
  addKeywordsDisplay = true;
  removeKeywordsDisplay = true;
  individualData: ImageIndividual;

  states: State[] = [];
  battles: Battle[] = [];
  armies: Army[] = [];
  weaponCategories: PrimaryWeapon[] = [];
  weapons: Weapon[] = [];
  relatedSets: RelatedSetLinkingModel[] = [];
  filteredRelatedSets: RelatedSetLinkingModel[] = [];
  relatedSetControl = new FormControl();
  boundSets: BoundImageSet[] = [];
  filteredBoundSets: BoundImageSet[] = [];
  boundSetControl = new FormControl();
  locations: string[] = [];
  filteredLocations: string[] = [];
  locationControl = new FormControl();
  companyLetters: string[] = [];
  regiments: Regiment[] = [];
  branches: BranchOfService[] = [];
  rankCats: RankCategory[] = [];
  ImageTypes = ImageTypes;
  Months = MONTHS;
  writeOrdinalSuffix = WriteOrdinalSuffixOfNumber;

  constructor(
    private imageSvc: ImageService,
    private relatedSetSvc: RelatedSetService,
    private boundSetSvc: BoundSetService,
    private lookupSvc: LookupDataService,
    private appInsights: AppInsightsService,
    protected notiSvc: StarbaseNotificationService,
    public appGlobalsSvc: AppGlobalsService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.setupData();

    this.relatedSetControl.valueChanges.subscribe(value => {
      this.record.relatedSetName = value;
      this.filterRelatedSets(value);
    });

    this.boundSetControl.valueChanges.subscribe(value => {
      this.record.boundSetName = value;
      this.filterBoundSets(value);
    });

    this.locationControl.valueChanges.subscribe((value: string) => {
      if (value) {
        this.record.location = value;
        this.filterLocations(value);
      }
    });
  }


  setupData() {
    this.record = new BatchEdit();

    this.lookupSvc.getAllRelatedSetLinks().subscribe(r => {
      this.relatedSets = r;
    });

    this.boundSetSvc.getAllData(this.boundSetSvc.getAllUri).subscribe (b => {
      this.boundSets = b;
    });

    this.imageSvc.getImageLocations().subscribe(l => {
      this.locations = l;
    });

    this.lookupSvc.getAllRequisiteData<State>(this.lookupSvc.getStatesUrl).subscribe(s => {
      this.states = AlphaSortArrayByProperty(s, 'state_Name');
    });

    this.lookupSvc.getAllRequisiteData<Battle>(this.lookupSvc.getBattlesUrl).subscribe(b => {
      this.battles = b;
    });

    this.lookupSvc.getAllRequisiteData<Army>(this.lookupSvc.getArmiesUrl).subscribe(a => {
      this.armies = a;
    });

    this.lookupSvc.getAllRequisiteData<RankCategory>(this.lookupSvc.getRankCatsUrl).subscribe(rc => {
      this.rankCats = rc;
    });

    this.lookupSvc.getAllRequisiteData<BranchOfService>(this.lookupSvc.getBranchesUrl).subscribe(b => {
      this.branches = b;
    });

    this.lookupSvc.getAllRequisiteData<Regiment>(this.lookupSvc.getRegimentNosUrl).subscribe(r => {
      this.regiments = r;
    });

    this.lookupSvc.getAllCompanyLetters().subscribe(cl => {
      this.companyLetters = cl;
    });

    this.lookupSvc.getAllRequisiteData<PrimaryWeapon>(this.lookupSvc.getPrimaryWeaponsUrl).subscribe(wc => {
      this.weaponCategories = wc;
    });

    this.lookupSvc.getAllRequisiteData<Weapon>(this.lookupSvc.getWeaponsUrl).subscribe(w => {
      this.weapons = w;
    });
  }

  changeSetMode(mode: number) {
    switch (mode) {
      case 1:
        this.setMode = 1;
        this.record.isRelatedSet = true;
        this.record.isBoundSet = false;
        this.record.boundSetName = '';
        break;
      case 2:
        this.setMode = 2;
        this.record.isBoundSet = true;
        this.record.isRelatedSet = false;
        this.record.relatedSetName = '';
        break;
      case 0:
      default:
        this.setMode = 0;
        this.record.isBoundSet = false;
        this.record.isRelatedSet = false;
        this.record.boundSetName = '';
        this.record.relatedSetName = '';
    }
  }

  filterRelatedSets(value: string) {
    const filterValue = value.toLowerCase();

    this.filteredRelatedSets = this.relatedSets.filter(set => set.name.toLowerCase().includes(filterValue));
  }

  filterBoundSets(value: string) {
    const filterValue = value.toLowerCase();

    this.filteredBoundSets = this.boundSets.filter(set => set.name.toLowerCase().includes(filterValue));
  }

  filterLocations(value: string) {
    const filterValue = value.toLowerCase();

    this.filteredLocations = this.locations.filter(loc => loc && loc.toLowerCase().includes(filterValue));
  }

  checkedOutEdited() {
    return this.record.checkedOut !== null && this.record.checkedOut !== undefined;
  }

  locationEdited() {
    return this.record.location && this.record.location.trim().length > 0;
  }

  changeLocationState(value: any): void {
    if (value === '' || value === 'null' || value === null || value === undefined || value === 'No state chosen') {
      this.record.locationState = null;
      this.record.locationStateID = null;
    } else {
      this.record.locationStateID = value;
      this.record.locationState = this.states.find(s => s.uid === value);
    }
  }

  stateEdited() {
    return this.record.locationStateID && this.record.locationStateID !== 0;
  }

  changeArmy(value: any): void {
    if (value === '' || value === 'null' || value === null || value === undefined || value === 'No army chosen') {
      this.record.army = null;
      this.record.armyId = null;
    } else {
      this.record.armyId = value;
      this.record.army = this.armies.find(a => a.uid === value);
    }
  }

  armyEdited() {
    return this.record.armyId && this.record.armyId !== 0;
  }

  notesEdited() {
    return this.record.notes && this.record.notes.trim().length > 0;
  }

  addKeyword(keyword: LU_Keyword, toAddArray = true) {
    if (toAddArray) {
      if (!this.record.addKeywords.some(k => k.uid === keyword.uid)) {
        this.record.addKeywords.push(keyword);
        this.addKeywordsDisplay = false;
        this.cd.detectChanges();
        this.addKeywordsDisplay = true;
      }
    } else {
      if (!this.record.removeKeywords.some(k => k.uid === keyword.uid)) {
        this.record.removeKeywords.push(keyword);
        this.removeKeywordsDisplay = false;
        this.cd.detectChanges();
        this.removeKeywordsDisplay = true;
      }
    }
  }

  removeKeyword(keyword: LU_Keyword, fromAddArray = true) {
    if (fromAddArray) {
      this.record.addKeywords = this.record.addKeywords.filter(k => k.uid !== keyword.uid);
    } else {
      this.record.removeKeywords = this.record.removeKeywords.filter(k => k.uid !== keyword.uid);
    }
  }

  keywordSearchError(err): void {
    console.error(err);
    this.appInsights.logError(err, { 'Keyword Search Error': 'Batch Edit'});
  }

  keywordsEdited(checkAddArray = true) {
    // eslint-disable-next-line max-len
    return checkAddArray ? this.record.addKeywords && this.record.addKeywords.length > 0 : this.record.removeKeywords && this.record.removeKeywords.length > 0;
  }

  addBattle(battle: Battle) {
    // WE FIRST FIND FOR REPEATS
    const el = this.record.addBattles.find(x => x.uid === battle.uid);

    if (!el) {
      if (this.imageType.uid !== ImageTypes['Letters & Diaries'] && this.record.addBattles.length > 0) {
        this.badDataEntered('Record may have only one battle.');
        return;
      }
    this.record.addBattles.push(battle);
    }
  }

  removeBattle(battle: Battle) {
    this.record.addBattles = this.record.addBattles.filter(b => b.uid !== battle.uid);
  }

  battleSearchError(err): void {
    console.error(err);
    this.appInsights.logError(err, { 'Battle Search Error': 'Batch Edit'});
  }

  battlesEdited() {
    return this.record.addBattles && this.record.addBattles.length > 0;
  }

  addDate() {
    const date = new ImageDate(0);
    date.uid = this.record.addDates.length > 0 ? this.record.addDates[this.record.addDates.length - 1].uid + 1 : 0;

    this.record.addDates.push(date);
  }

  removeDate(date: ImageDate) {
    this.record.addDates = this.record.addDates.filter(d => d.uid !== date.uid);
  }

  datesEdited() {
    return this.record.addDates && this.record.addDates.length > 0;
  }

  enforceDayMinMax(date: ImageDate) {
    if (date.day && date.day > 31) {
      date.day = 31;
    } else if (date.day && date.day < 0) {
      date.day = 0;
    }
  }

  enforceYearMinMax(date: ImageDate) {
    if (date.year && date.year > 3000) {
      date.year = 3000;
    } else if ((date.year || date.year === 0) && date.year < 1) {
      date.year = 1;
    }
  }

  addUnit(unit: { army: UnitArmies; corps: number; regiment: Regiment; state: State; branch: BranchOfService; coLetters: string[] }) {
    const ul = new UnitLinking();
    ul.uid = this.record.addUnits.length > 0 ? this.record.addUnits[this.record.addUnits.length - 1].uid + 1 : 0;
    ul.army = unit.army;
    ul.corps = unit.corps;
    ul.regimentNo = unit.regiment;
    ul.state = unit.state;
    ul.branch = unit.branch;
    ul.companyLetters = unit.coLetters.join();
    ul.branchId  = ul.branch !== null ? unit.branch.uid : null;
    ul.branchName = ul.branch !== null ? ul.branch.branchName : null;
    ul.stateId = ul.state !== null ? unit.state.uid : null;
    ul.stateName = ul.state !== null ? ul.state.state_Name : null;
    ul.regimentNoId = ul.regimentNo !== null ? unit.regiment.uid : null;
    ul.regimentNumberDisplay = ul.regimentNo !== null ? WriteOrdinalSuffixOfNumber(ul.regimentNo.regimentNo) : null;

    this.record.addUnits.push(ul);
  }

  removeUnit(unit: UnitLinking) {
    this.record.addUnits = this.record.addUnits.filter(u => u.uid !== unit.uid);
  }

  unitsEdited() {
    return this.record.addUnits && this.record.addUnits.length > 0;
  }

  addWeapon() {
    const weapon = new WeaponLinking();
    weapon.uid = this.record.addWeapons.length > 0 ? this.record.addWeapons[this.record.addWeapons.length - 1].uid + 1 : 0;

    this.record.addWeapons.push(weapon);
  }

  setWeaponCategory(catUid: number, weapon: WeaponLinking) {
    weapon.primaryWeapon = this.weaponCategories.filter(wc => wc.uid === +catUid)[0];
  }

  filteredWeapons(weapon: WeaponLinking): Weapon[] {
    if (this.record.addWeapons && this.record.addWeapons.length) {
      if (weapon?.primaryWeapon) {
        return this.weapons.filter(w => w.primaryWeaponUID === weapon.primaryWeapon.uid);
      } else {
        return this.weapons;
      }

    }
  }

  removeWeapon(weapon: WeaponLinking) {
    this.record.addWeapons = this.record.addWeapons.filter(w => w.uid !== weapon.uid);
  }

  weaponsEdited() {
    return this.record.addWeapons && this.record.addWeapons.length > 0;
  }

  addQm(manual: QMManual) {
    const qm = new QMManualLink();
    qm.qM_ManualModel = manual;
    qm.qM_ManualModelUID = manual.uid;

    this.record.addContractItems.push(qm);
  }

  mapQMLinkArray() {
    let resultArray: QMManual[] = [];
    if (this.record.addContractItems && this.record.addContractItems.length) {
      resultArray = this.record.addContractItems.map(linkItem => {
        const item = linkItem.qM_ManualModel;
        item.editable = true;
        item.createdByUser = linkItem.createdByUser;
        item.createdDateTime = linkItem.createdDateTime;
        return item;
      });
    }

    return resultArray;
  }

  removeQm(manual: QMManual) {
    this.record.addContractItems = this.record.addContractItems.filter(qm => qm.qM_ManualModelUID !== manual.uid);
  }

  qmSearchError(err): void {
    console.error(err);
    this.appInsights.logError(err, { 'Quartermaster Spec Search error': 'Batch Edit' });
  }

  qmEdited() {
    return this.record.addContractItems && this.record.addContractItems.length > 0;
  }

  addImageIndividual(): void {
      this.individualEditMode = false; // add mode
      this.individualData = new ImageIndividual();
      this.individualData.rank = new Rank();
      this.individualData.regimentNo = new Regiment();
      this.individualData.state = new State();
      this.individualData.branch = new BranchOfService();
      this.individualData.companyLetters = '';
      this.showIndividualEditor = true;
    }

  editIndividual(ind: ImageIndividual): void {
    this.individualEditMode = true;
    this.individualData = JSON.parse(JSON.stringify(ind)); // deref the obj
    // this.backupIndividual = JSON.parse(JSON.stringify(ind));
    this.showIndividualEditor = true;
    /* if the record being edited is still 'new' (not yet saved to server),
    ** then remove it from the array of individuals so the modified version can be re - added. */
    if (ind.uid === 0) {
      const idx = this.record.addIndividuals.findIndex(
        i => i.uid === 0
          && i.firstName === ind.firstName
          && i.lastName === ind.lastName);
      this.record.addIndividuals.splice(idx, 1);
    }
  }

  doneAddingIndividual(ind: ImageIndividual) {
    this.record.addIndividuals.push(ind);
    this.showIndividualEditor = false;
  }

  doneEditingIndividual(ind: ImageIndividual) {
    if (ind.uid && ind.uid > 0) {
      const overwriteIdx = this.record.addIndividuals.findIndex(i => i.uid === ind.uid);
      this.record.addIndividuals[overwriteIdx] = ind;
    } else {
      this.record.addIndividuals.push(ind);
    }
    this.showIndividualEditor = false;
  }

  cancelIndividualChanges() {
    this.showIndividualEditor = false;
    this.individualData = null;
  }

  individualsEdited() {
    return this.record.addIndividuals && this.record.addIndividuals.length > 0;
  }

  /** Will post an Error type notification to the Notification Service.
   * To be used when the user entered invalid input.
   *
   * @param message Optional. Will display this text in the notification.
   */
  badDataEntered(message = ''): void {
    if (message === '') {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Invalid Data',
          'Please enter valid data before saving.',
          undefined, undefined, StarbaseNotificationSentiment.Error));
    } else {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Invalid Data',
          message, undefined, undefined, StarbaseNotificationSentiment.Error));
    }
  }

  confirmBatchEdit() {
    this.record.imageModelUIDs = this.imageModels.map(i => i.uid);

    this.processCompleteEmitter.emit(this.record);
  }

  closeBatchEdit() {
    this.closeEmitter.emit();
  }
}
